/* theme-runtime.js — Addi Parati theme runtime shims.
 *
 * Extracted from layout/theme.liquid (D7, 2026-09-07) so the ~10 KB no longer
 * ships inline on every page. Load as:  {{ 'theme-runtime.js' | asset_url | script_tag: defer: true }}
 *
 * Blocks (in this order in the file):
 *   C. Runtime string translator           — was inline <script> at theme.liquid:487-641.
 *                                            51 en→it phrase pairs + tree walker + persistent
 *                                            MutationObserver. Kept as-is; tech debt tracked as BS-13
 *                                            (migrate theme strings to locales/it.json, fix quote-app
 *                                            + Shopify Forms labels at source, then remove).
 *   D. ACCEDI-button injector              — was inline <script> at theme.liquid:642-782.
 *                                            Fired on setTimeout(2000) after load; now triggered by
 *                                            a shared MutationObserver as soon as the form
 *                                            renders.
 *
 * The companion stylesheet assets/theme-runtime.css carries the .custom-login-after-submit-btn
 * rules that were block E of the old inline set.
 */

(function () {
  'use strict';

  // -----------------------------------------------------------------------------------------------
  // Shared MutationObserver for block D.
  // Fires on any subtree addition to document.body; the handler is idempotent (module-scoped flag
  // so it never runs twice for the same DOM).
  // -----------------------------------------------------------------------------------------------

  var accediPage =
    location.pathname.replace(/\/$/, '') === '/pages/private-customer' ||
    location.pathname.replace(/\/$/, '') === '/pages/conto-interior-designer-e-architetti';
  var accediButtonAdded = false;

  // Block D — ACCEDI-button injector.
  function findAccediTarget(root) {
    root = root || document;
    // Primary: Shopify Forms extension (forms-2560) mounts as <shopify-forms-embed id="app-embed">
    // with the actual form fields inside its shadow root. Anchor next to the embed itself so
    // the ACCEDI link sits directly under the visible form.
    var embed = root.querySelector('shopify-forms-embed');
    if (embed) return embed;
    // Server-rendered app-block placeholder — present in the initial HTML on
    // /pages/private-customer before the extension hydrates.
    var block = root.querySelector('div.shopify-block.shopify-app-block[id*="_forms_inline_"]');
    if (block) return block;
    // Legacy fallbacks — older Shopify Forms markup that emitted _formHeader / _formSubmitButton
    // class hashes into light DOM. Retained defensively; do not gate on them.
    var header =
      root.querySelector('section[class*="_formHeader"]') ||
      root.querySelector('[class*="_formHeader"]');
    if (header) return header;
    var headings = root.querySelectorAll('h1, h2, h3');
    for (var i = 0; i < headings.length; i++) {
      var text = (headings[i].textContent || '').trim().toLowerCase();
      if (text === 'iscriviti') {
        return headings[i].closest('section') || headings[i].parentElement;
      }
    }
    var submit =
      root.querySelector('button[data-testid="btn-form-submit"]') ||
      root.querySelector('button[class*="_formSubmitButton"]');
    if (submit) return submit;
    var buttons = root.querySelectorAll('button');
    for (var j = 0; j < buttons.length; j++) {
      var t = (buttons[j].textContent || '').trim().toLowerCase();
      if (t === 'invia') return buttons[j];
    }
    return null;
  }
  function injectAccediButton() {
    if (!accediPage || accediButtonAdded) return;
    if (document.querySelector('.custom-login-after-submit-btn')) {
      accediButtonAdded = true;
      return;
    }
    var target = findAccediTarget(document);
    if (!target) return;
    var a = document.createElement('a');
    a.href = '/account/login';
    a.className = 'custom-login-after-submit-btn';
    a.textContent = 'ACCEDI AL TUO CONTO';
    target.insertAdjacentElement('afterend', a);
    accediButtonAdded = true;
  }

  function startSharedObserver() {
    // Initial pass on whatever has already rendered.
    injectAccediButton();
    // Watch for later Shopify Forms hydration and any dynamic re-mount.
    var mo = new MutationObserver(function (mutations) {
      var needsScan = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { needsScan = true; break; }
      }
      if (needsScan) injectAccediButton();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    // Defensive fallbacks — Forms may hydrate before the observer attaches or via mechanisms
    // that don't fire document.body childList mutations. injectAccediButton is idempotent
    // (accediButtonAdded flag), so re-entry is cheap.
    window.addEventListener('load', injectAccediButton);
    document.addEventListener('shopify:section:load', injectAccediButton);
    setTimeout(injectAccediButton, 500);
    setTimeout(injectAccediButton, 1500);
    setTimeout(injectAccediButton, 3000);
  }

  // -----------------------------------------------------------------------------------------------
  // Block C — runtime string translator.
  // Verbatim from the old inline block. TECH DEBT (BS-13): migrate the theme-string subset to
  // locales/it.json and fix quote-app + Shopify Forms English labels at source; then remove.
  // -----------------------------------------------------------------------------------------------

  var translations = [
    ["Classic curtain making service", "Tenda classica"],
    ["Fabric for classic curtains", "Tessuto per tende a caduta"],
    ["Curtain type", "Tipo di tenda"],
    ["Product URL", "Link al prodotto"],
    ["Product SKU", "Codice prodotto"],
    ["Product name", "Nome"],
    ["Fabric required", "Quantità di tessuto necessaria"],
    ["Fabric total", "Totale tessuto"],
    ["Classic curtains", "Tende a caduta"],
    ["Item type", "Articolo"],
    ["Per panel", "Prezzo per pannello"],
    ["Panels", "pannelli"],
    ["Height", "Altezza"],
    ["Width", "Larghezza"],
    ["Curtain making service", "Confezionamento tende"],
    ["prezzo per pannello", "Servizio confezionamento tende"],
    ["Technical specifications", "Scheda tecnica"],
    ["Weight", "Peso"],
    ["Usage", "Uso"],
    ["both", "Tende e tappezzeria"],
    ["Horizontal Repeat", "Rapporto di disegno orizzontale"],
    ["Vertical repeat", "Rapporto di disegno verticale"],
    ["Made in", "Origine"],
    ["Outdoor", "Uso in esterni"],
    ["Lightfastness", "Resistenza alla luce"],
    ["Fire certification", "Certificazione ignifuga"],
    ["Fabric Larghezza", "larghezza tessuto"],
    ["Fabric unit step", "Gradino unitario del tessuto"],
    ["Fabric sale unit", "Unità di vendita"],
    ["Surface", "Superficie"],
    ["Horizontal repeat", "Rapporto di disegno orizzontale"],
    ["Shipping", "SPEDIZIONI"],
    ["Rendered", "RESI"],
    ["Related Products", "PRODOTTI SIMILI"],
    ["Calculate your price", "CONFIGURA IL TUO MURALE"],
    ["WALL ALTEZZA (cm)", "Altezza parete (cm)"],
    ["WALL LARGHEZZA (cm)", "Larghezza parete/i (cm)"],
    ["NEED A DIFFERENT SIZE?", "VUOI UNA MISURA DIVERSA?"],
    ["Request a quote for a custom size", "Chiedi un preventivo"],
    ["Custom altezza (cm)", "Altezza (cm)"],
    ["Custom Larghezza (cm)", "Larghezza  (cm)"],
    ["Email address", "Email"],
    ["Additional notes (optional)", "Note"],
    ["I agree to receive marketing emails and communications.", "Voglio ricevere messaggi informativi, sconti e comunicazioni di marketing."],
    ["SUBMIT CUSTOM SIZE ENQUIRY", "INVIA"],
    ["Panel Larghezza", "Larghezza murale"],
    ["Panel altezza", "Altezza murale"],
    ["care maintenance", "Cura del prodotto"],
    ["Water repellent", "impermeabile"],
    ["Fire retardant certified", "Disponibile su richiesta"],
    ["Sustainable", "Ecologico"],
    ["Sustainability", "Ecologico"],
    ["SOLD OUT", "ESAURITO"]
  ];

  function shouldSkipElement(el) {
    if (!el) return false;
    var skipTags = ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'IFRAME'];
    if (skipTags.indexOf(el.tagName) !== -1) return true;
    if (el.classList && el.classList.contains('notranslate')) return true;
    if (el.getAttribute && el.getAttribute('translate') === 'no') return true;
    return false;
  }
  function replaceInsensitive(text, from, to) {
    return text.replace(new RegExp(from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), to);
  }
  function translateTextNode(node) {
    var text = node.nodeValue;
    if (!text || !text.trim()) return;
    var newText = text;
    translations.forEach(function (pair) { newText = replaceInsensitive(newText, pair[0], pair[1]); });
    if (newText !== text) node.nodeValue = newText;
  }
  function translateElement(root) {
    if (!root || shouldSkipElement(root)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.parentElement || shouldSkipElement(node.parentElement)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) translateTextNode(node);
  }
  function runTranslation() { translateElement(document.body); }

  function startTranslator() {
    runTranslation();
    window.addEventListener('load', function () {
      runTranslation();
      setTimeout(runTranslation, 500);
      setTimeout(runTranslation, 1500);
      setTimeout(runTranslation, 3000);
    });
    document.addEventListener('shopify:section:load', runTranslation);
    var translationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) translateElement(node);
          if (node.nodeType === 3) translateTextNode(node);
        });
      });
    });
    translationObserver.observe(document.body, { childList: true, subtree: true });
  }

  // -----------------------------------------------------------------------------------------------
  // Boot on DOMContentLoaded (or immediately if we already fired).
  // -----------------------------------------------------------------------------------------------

  function boot() {
    startSharedObserver();
    startTranslator();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
